import React from 'react';
import { Column } from '@ant-design/plots';

const ColumnChartImobServices = (props) => {
    const mockData = [
        { realEstate: 'Imobiliaria A', appointments: 30 },
        { realEstate: 'Imobiliaria B', appointments: 45 },
        { realEstate: 'Imobiliaria C', appointments: 25 },
    ];

    const config = {
        data: mockData,
        xField: 'realEstate',
        yField: 'appointments',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 1,
            },
        },
        color: ({ realEstate }) => {
            switch (realEstate) {
                case 'Imobiliaria A':
                    return '#1E90FF';
                case 'Imobiliaria B':
                    return '#32CD32';
                case 'Imobiliaria C':
                    return '#FF4500';
                default:
                    return '#d9d9d9';
            }
        },
        xAxis: {
            label: {
                autoHide: false,
                autoRotate: false,
            },
        },
        meta: {
            realEstate: {
                alias: 'Imobiliária',
            },
            appointments: {
                alias: 'Atendimentos',
            },
        },
        animation: false,
        height: 250,
    };
    return <Column {...config} />;
};

export default ColumnChartImobServices;